import React, { useEffect, useState } from "react";

import { Pagination } from "@mui/material";

import { getBuisnessFromAgreegatorsApi } from "../../../Marketing/maketingComponents/actioncreator";
import Skeleton from "react-loading-skeleton";

const BuisnessAggregator = ({ payload, applyFilter, clearApplyFilter}) => {
    const [loaderState, setLoaderState] = useState(false)
    const [count, setCount] = useState(0);
    const [pageNo, setPage] = useState(1);
    const [noOfEntry, setnoOfEntry] = useState(10);
    const [objectData, setObjectData] = useState('');
    
   

  
    const getData = () => {
        setLoaderState(true)
        getBuisnessFromAgreegatorsApi(payload, pageNo, noOfEntry, callback => {
            setObjectData(callback)
            setLoaderState(false)
            clearApplyFilter()
        })
    }
    useEffect(() => {
        getData()
    }, [])

    useEffect(() => {
        if(applyFilter == true){
            getData()
        }
    }, [applyFilter])
    return (
        <>
           <div className="" style={{ marginTop:window.innerWidth > 1800 ? "60px" :'30px',marginBottom: '20px', borderRadius: '10px', minHeight: '600px',boxShadow:'0px 2px 6px 4px rgba(50, 71, 92, 0.02), 0px 2px 9px 0px rgba(50, 71, 92, 0.04), 3px 4px 4px 0px rgba(0, 0, 0, 0.25)' }}>
           <div className="bg-white p-4 " style={{ padding: '15px' }}>
                    <h5 style={{ color: '#1d3557', fontWeight: '700' }}> <strong style={{ paddingTop: '10px' }}>Business from Aggregators</strong></h5>

                 


                    <div className='credit-table'>
                        <table>
                            <thead style={{  }}>
                                <tr className="thead-class">
                                    <th className="">Aggregator Name</th>
                                    <th className="">Fresh Leads</th>
                                    <th className="">Fresh Approvals</th>
                                    <th className="">Fresh Disbursement</th>
                                    <th className="">CPA</th>
                                    <th className="">Total Cost</th>
                                    <th className="">Repeat Leads</th>
                                    <th className="">Repeat Approvals</th>
                                    <th className="">Repeat Disbursements</th>
                                    <th className="">Total Leads</th>
                                    <th className="">Amount Disbursement</th>
                                </tr>
                            </thead>
                            <tbody>

                                {objectData !== '' && objectData.map((data, i) => {
                                    return (
                                        <tr style={{ borderBottom: "none" }}>
                                            <td scope="col">{data.aggregatorName} </td>
                                            <td scope="col">{data.freshLeads} </td>
                                            <td scope="col">{data.freshApprovals} </td>
                                            <td scope="col">{data.freshDisbursement} </td>
                                            <td scope="col">{data.cpa} </td>
                                            <td scope="col">{data.totalCost} </td>
                                            <td scope="col">{data.repeatLeads} </td>
                                            <td scope="col">{data.repeatApprovals} </td>
                                            <td scope="col">{data.repeatDisbursement} </td>
                                            <td scope="col">{data.totalLeads} </td>
                                            <td scope="col">{data.amountDisbursement} </td>

                                        </tr>
                                    )
                                })}
                                {loaderState ?
                                    <>
                                        <tr>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                        </tr>
                                        <tr>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                        </tr>
                                        <tr>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                        </tr>
                                        <tr>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                        </tr>
                                        <tr>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                        </tr>   <tr>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                        </tr>
                                        <tr>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                            <td><Skeleton height={40} /></td>
                                        </tr>
                                    </>
                                    : ""}



                            </tbody>
                        </table>
                    </div>
                    {count > 1 ?
                        <div className="row">

                            <div className='col-sm-1 ' style={{ marginTop: '14px', textAlign: 'end' }} >
                                <b > Page :</b>
                            </div>
                            <div className="col-sm-1">
                                <select className="form-control">
                                    <option>1</option>
                                </select>
                            </div>
                            <div className='col-sm-1 ' style={{ marginTop: '14px', textAlign: 'start' }} >
                                <b > of &nbsp; 0</b>
                            </div>
                            <div className="col-sm-5"></div>

                            <div className="col-sm-4"> <div style={{ float: 'right', marginTop: '10px', marginBottom: '10px', marginRight: '40px' }}>
                                <Pagination count={10} color="primary"
                                    shape="circle"
                                // onChange={changeHandler}
                                />
                            </div></div>
                        </div>
                        : ""}
                </div>

            </div>
        </>

    );
}

export default BuisnessAggregator;
